import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getUserSettingsState = ({ userSettings }: RootState) => userSettings;

export const settingsSelector = createSelector([getUserSettingsState], (data) => data);
